var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoDaily(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 114.2 114.2",
    style: {
      enableBackground: "new 0 0 114.2 114.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,41.8c-8.5,19.9,0.9,43,20.8,51.5s43-0.9,51.5-20.8s-0.9-43-20.8-51.5C52.5,12.6,29.4,21.9,21,41.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.1,53.6l-13-13c4.1,10.3,4.4,22.1,0,33.1l13-13C114.1,58.7,114.1,55.6,112.1,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1,53.6c-2,2-2,5.1,0,7.1l13,13c-4.1-10.3-4.4-22.1,0-33.1L2.1,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5,99.1l13,13c2,2,5.1,2,7.1,0l13-13C63.3,103.2,51.5,103.5,40.5,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6,2.1l-13,13c10.3-4.1,22.1-4.4,33.1,0l-13-13C58.7,0.1,55.5,0.1,53.6,2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,98.6l18.4,0c2.8,0,5-2.2,5-5V75.2C94,85.3,85.9,93.9,75,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7,20.7v18.4C20.1,29,28.2,20.4,39.1,15.7l-18.4,0C17.9,15.7,15.7,18,15.7,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6,75.1l0,18.4c0,2.8,2.2,5,5,5h18.4C28.9,94.1,20.3,86,15.6,75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5,15.7H75.1c10.2,4.4,18.7,12.5,23.4,23.4l0-18.4C98.5,18,96.3,15.7,93.5,15.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDaily);
export default __webpack_public_path__ + "static/media/ico-daily.70d844733c3367763a9b4b74cf1b479c.svg";
export { ForwardRef as ReactComponent };